import { Row, Spin } from 'antd';
import clsx from 'clsx';
import Button from 'components/Button';
import Empty from 'components/Empty';
import Text from 'components/Text';
import userSelectors from 'features/user/services/selectors';
import styled from 'styled-components';
import AptGroupByTimeItem from './AptGroupByTimeItem';
import { IAptGroupByTimeAppointmentData } from 'features/user/services/types/apt';
import AptModalDetail, { IAptModalDetailRef } from './DetailModal';
import { useRef } from 'react';

const HomeAptByGroupTime = () => {
  const aptGroupByTime = userSelectors.getAptGroupByTime();
  const loading = userSelectors.getAptGroupByTimeLoading();
  const aptModalDetailRef = useRef<IAptModalDetailRef>(null);

  const onAppointmentClick = (apt: IAptGroupByTimeAppointmentData) => {
    aptModalDetailRef.current?.open(apt);
  };

  const RowData = () => {
    if (loading) return <Spin />;

    return aptGroupByTime.length > 0 ? (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: '8px',
        }}
      >
        {aptGroupByTime.map((o) => (
          <AptGroupByTimeItem
            key={o.time}
            data={o}
            onAppointmentClick={onAppointmentClick}
          />
        ))}
      </div>
    ) : null;
  };

  return (
    <Styled className={clsx('ticket-label-section', 'v2')}>
      <Row
        className='top-title'
        align={'middle'}
        style={{ gap: '8px', borderRight: '1px solid #ADADAD' }}
      >
        <WaitingListLabel>
          <Text
            className='label-text'
            variant='H7'
            style={{ color: '#2D6772', fontWeight: '700' }}
          >
            APPOINTMENTS
          </Text>
          <Text style={{ flex: 1 }} />
          {/* {waitingList.length > 0 ? (
            <ButtonRemoveTicket active={activeRemoveWaiting} onToggle={onToggle} />
          ) : (
            <div style={{ height: '2.5rem' }}></div>
          )} */}
          {/* <SummaryWaitingList waitingList={waitingList} /> */}
          <AptInfoTotal>
            <span className='num'>{aptGroupByTime.reduce((acc, curr) => acc + curr.totalAppointments, 0)}</span>
            <span className='apt'>APPTS</span>
          </AptInfoTotal>
        </WaitingListLabel>
      </Row>
      <div className='box-div-scroll'>
        <RowData />
      </div>
      <AptModalDetail ref={aptModalDetailRef} />
    </Styled>
  );
};

export default HomeAptByGroupTime;

const AptInfoTotal = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  span.num {
    color: #1D2129;
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
  }

  span.apt {
    color: #505050;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;


const Styled = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0;
  background: #8defab4d;
  .box-div-scroll {
    flex: 1;
    margin: 0 -1rem;
    padding: 0 1rem;
    background: transparent;
    padding-top: 1rem;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox 64 */
    border-right: 1px solid #ccd4dc;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }

  &.v2.ticket-label-section {
    padding-top: 0;
    background: transparent;
    .top-title {
      background: #fff;
      height: 64px;
      min-height: 64px;
      max-height: 64px;
      overflow: hidden;
      margin: 0 -1rem;
      padding: 0 1rem;
      .label-text {
        font-size: 22px;
        text-transform: uppercase;
        display: flex;
        align-items: center;
      }
    }
  }
`;

const WaitingListLabel = styled.div`
  width: 100%;
  display: flex;
  overflow-x: auto;
  gap: 16px;
  white-space: nowrap;

   scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
